export default "__VITE_ASSET__CvFG$upY__"